import * as React from "react";
import {createRoot} from "react-dom/client";
import {App} from "./components/App";
import {PluginApiContext, PluginApi} from "./services/PluginApi";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query"
import {apiBaseUrl, isDev} from "./config";
import SelectedItemDetails = Office.SelectedItemDetails;
import {GraphApi, GraphApiContext} from "./services/GraphApi";
import {getAccessToken2, initAuth} from "./auth";

/* global document, Office, module, require */

export let UserId: string = '';

const rootElement: HTMLElement = document.getElementById("container");
const root = createRoot(rootElement);

/* Render application after Office initializes */
Office.onReady(async () => {

    let accessToken = "";
    try {
        await initAuth();
        accessToken = await getAccessToken2();
        if (isDev)
            console.log(accessToken);
        
        // Get subjectId from token
        const tokenBody = accessToken.split('.')[1];
        const tokenBodyJson = JSON.parse(atob(tokenBody));
        UserId = tokenBodyJson['oid'].toLowerCase();

    } catch (error) {
        console.error("ERROR: Could not get SSO access token 1", error)
        return
    }

    setTimeout(async () => {
    const pluginApi = new PluginApi(apiBaseUrl, getAccessToken2);
    const graphApi = new GraphApi(pluginApi);
    const queryClient = new QueryClient();
    
    pluginApi.registerOpen().then(_ => {});

        root.render(
            // <React.StrictMode>
            <QueryClientProvider client={queryClient}>
                <PluginApiContext.Provider value={pluginApi}>
                    <GraphApiContext.Provider value={graphApi}>
                        <App officeContext={Office.context}/>
                    </GraphApiContext.Provider>
                </PluginApiContext.Provider>
            </QueryClientProvider>
            // </React.StrictMode>
        );
    }, 0)
});

if ((module as any).hot) {
    (module as any).hot.accept("./components/App", () => {
        const NextApp = require("./components/App").default;
        root.render(NextApp);
    });
}
